module.exports = __webpack_public_path__ + "static/img/2_8_1.6f0676f2.jpg";